import { render, staticRenderFns } from "./BannerInputMedia.vue?vue&type=template&id=2dca1862&scoped=true&"
import script from "./BannerInputMedia.vue?vue&type=script&lang=js&"
export * from "./BannerInputMedia.vue?vue&type=script&lang=js&"
import style0 from "./BannerInputMedia.vue?vue&type=style&index=0&id=2dca1862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca1862",
  null
  
)

export default component.exports